import ApiService from './api.service';

class SalePointService {
  async list() {
    try {
      const response = await ApiService.get('/sale-point');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async create(data) {
    try {
      const response = await ApiService.post('/sale-point/add', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async update(data) {
    try {
      const response = await ApiService.put('/sale-point/update', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async delete(id) {
    try {
      const response = await ApiService.delete('/sale-point/delete', { id });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new SalePointService(); 